export default __webpack_public_path__ + "static/media/SuppliersPriceChangeOrangeIcon.d641a073.png";